import React from 'react';
import { Modal, ModalHeader } from 'reactstrap';
import WaterRightsStatusForm from '../Forms/WaterRightsStatusForm';

const AddEditWaterRightsStatusModal = ({
	dataWaterRightsStatus,
	isOpen,
	isEdit,
	handleToggleModal,
	activeTab,
	toggleTab,
	toggleRefetch,
}) => {
	return (
		<Modal
			isOpen={isOpen}
			toggle={handleToggleModal}
			size='xs'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
		>
			<ModalHeader toggle={handleToggleModal}>
				{isEdit ? 'Editar' : 'Agregar'} Estado de Derecho de Agua
			</ModalHeader>

			<WaterRightsStatusForm
				dataWaterRightsStatus={dataWaterRightsStatus}
				isOpen={isOpen}
				isEdit={isEdit}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
				toggleRefetch={toggleRefetch}
			/>
		</Modal>
	);
};

export default AddEditWaterRightsStatusModal;
